import React from 'react';
import styled from 'styled-components';
import Triangle from '../Triangle/Triangle';
import LandingWrapper from '../LandingWrapper/LandingWrapper';
import { HeaderWrapper } from '../HeaderWrapper/HeaderWrapper';
import ErgoImg from './assets/ErgoImage.png';

const ErgoSection = () => {
  const title = 'We collaborate with ERGO, specialist in travel insurance.';
  const description =
    'Their international network ensures you receive the best care before, during, and after your trip. ERGO is part of Munich Re, one of the world’s leading reinsurers, for guaranteed peace of mind﻿!';
  return (
    <>
      <Background>
        <Triangle color='#FFF6EF' />
        <LandingWrapper>
          <ImageWrapper>
            <Image src={ErgoImg} />
          </ImageWrapper>
          <Container>
            <HeaderWrapper titleText={title} paragraphText={description} />
          </Container>
        </LandingWrapper>
      </Background>
    </>
  );
};

export default ErgoSection;

const Background = styled.div`
  width: 100%;
  background-color: #fff6ef;
  padding: 2rem 2rem;
  position: relative;
  padding-bottom: 80px;

  @media (min-width: 768px) {
    padding: 4rem 2rem;
    padding-bottom: 80px;
  }

  @media (min-width: 1024px) {
    padding-bottom: 90px;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;

  @media (min-width: 768px) {
    margin-bottom: 60px;
  }

  @media (min-width: 1024px) {
    margin-bottom: 80px;
  }
`;

const Image = styled.img`
  width: 100%;
  height: auto;

  @media (min-width: 768px) {
    height: 450px;
    width: auto;
  }

  @media (min-width: 1024px) {
    height: 600px;
    width: auto;
  }
`;

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 1040px;
  margin: 0 auto;
`;
